// Datas civis 'AAAA-MM-DD' no navegador, sem deslocamento de fuso: toda aritmética é feita
// ao meio-dia UTC. "Hoje" é sempre calculado no fuso do LAR, não no do aparelho.

export function todayIn(timeZone) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
}

function toDate(d) {
  return new Date(`${d}T12:00:00Z`);
}

export function addDays(d, n) {
  const dt = toDate(d);
  dt.setUTCDate(dt.getUTCDate() + n);
  return dt.toISOString().slice(0, 10);
}

export function addMonths(d, n) {
  const dt = toDate(d);
  const day = dt.getUTCDate();
  dt.setUTCDate(1);
  dt.setUTCMonth(dt.getUTCMonth() + n);
  const last = new Date(Date.UTC(dt.getUTCFullYear(), dt.getUTCMonth() + 1, 0)).getUTCDate();
  dt.setUTCDate(Math.min(day, last));
  return dt.toISOString().slice(0, 10);
}

export function diffDays(from, to) {
  return Math.round((toDate(to) - toDate(from)) / 86_400_000);
}

export function weekdayOf(d) {
  return toDate(d).getUTCDay();
}

export function startOfWeek(d, weekStartsOn = 0) {
  return addDays(d, -((weekdayOf(d) - weekStartsOn + 7) % 7));
}

export function monthKey(d) {
  return d.slice(0, 7);
}

export function monthStart(d) {
  return `${d.slice(0, 7)}-01`;
}

export function monthEnd(d) {
  return addDays(addMonths(monthStart(d), 1), -1);
}

/** Partes locais de um instante ISO no fuso do lar. */
export function localParts(iso, timeZone) {
  const f = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(iso));
  const p = Object.fromEntries(f.map((x) => [x.type, x.value]));
  return { date: `${p.year}-${p.month}-${p.day}`, time: `${p.hour}:${p.minute}` };
}
